import { worker } from './browser';
import { DB } from './db';

export function startMSW(): void {
    DB.Seed();
    worker.start({
        quiet: true,
        onUnhandledRequest: 'bypass',
        serviceWorker: {
            options: { scope: '/' },
        },
    });
}
